import { render, staticRenderFns } from "./CnaeTabela.vue?vue&type=template&id=23e5f398&"
import script from "./CnaeTabela.vue?vue&type=script&lang=js&"
export * from "./CnaeTabela.vue?vue&type=script&lang=js&"
import style0 from "./CnaeTabela.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports